import { ConsentTypeValidityModeDateEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { ConsentTypeValidityMode } from '@/services/graphql/types';

export const mapperConsentTypeValidityModeDateEnum = createEnumMapperFunction(
  ConsentTypeValidityMode,
  ConsentTypeValidityModeDateEnum
);
